import { useWeb3React } from '@web3-react/core'
import Supply from './components/Supply'
import Balance from "./components/Balance";
import Modal from "./components/Modal";
import Mint from "./components/Mint";
import {useEffect} from 'react';
import config from './config.json'
import NFT from './NFT.gif'
import Status from "./components/Status";
import './App.css'


function App() {
  const { active } = useWeb3React();
  useEffect(() => {
    localStorage.clear()
  },[])  
  return (
    <div className="App h-screen bg-black relative">
          <Balance/>
          <Status/>
      <div className='h-screen grid place-items-center'>
        <div className=" w-60 md:w-auto">
          <h1 className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500 text-xl md:text-3xl font-extrabold text-center">VentiHeadz 80s Collection</h1>
          <p className="invisible absolute md:visible md:relative text-white mt-4 font-bold text-center">A NFT Collection Brought to you by VentiSwap</p>
          <a href={config.MARKETPLACE_LINK}><button type="button" className="mt-4 w-full text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">View Collection on OpenSea</button></a>
          <Supply/>
          <img alt='nft' className='mx-auto w-72 md:w-96 mt-4 rounded-lg' src={NFT}/>
          {active ? <Mint/>: <Modal/>} 
        </div>
      </div>
    </div>
  );
}

export default App;
